import React, { useState, useEffect } from "react";
import apiService from "apiService";
import Alert from "view/component/Alert";
import { setAgeFromVisit } from "view/component/helper/helper";
import BlobPrint from "view/component/BlobPrint";

const Mtbs = (props) => {
  const [refMtbs, setRefMtbs] = useState([]);
  const [param, setParam] = useState({
    visit_id: props.detilPx.id,
    user_id: JSON.parse(localStorage.getItem("userData")).id,
    usia: 2,
  });
  const getPertanyaan = async () => {
    let age = getAge();
    let res = await apiService.get("/management/mtbs/read/" + props.detilPx.id);
    if (res && res.code === 200) {
      setRefMtbs(res.data);
      setParam({ ...param, usia: age });
    } else {
      let resx = await apiService.get("/management/mtbs/question/" + age);
      if (resx && resx.code === 200) {
        setRefMtbs(resx.data);
        setParam({ ...param, usia: age });
      }
    }
  };
  useEffect(() => {
    getPertanyaan();
  }, [refMtbs.length]);

  const handleCheck = (e) => {
    let id = e.target.id;
    let check = e.target.value;
    if (check === "true") {
      check = 0;
    } else {
      check = 1;
    }
    setParam({
      ...param,
      [id]: check,
    });
    console.log(param);
  };

  const handleInput = (e) => {
    let id = e.target.id;
    let check = e.target.value;
    setParam({
      ...param,
      [id]: check,
    });
  };

  const post = async () => {
    let res = await apiService.post("/management/mtbs/create", param);
    if (res.code === 200) {
      Alert("success", "data disimpan");
    } else {
      Alert("error", "gagal menyimpan data");
    }
  };

  const getAge = () => {
    let age = setAgeFromVisit(
      props.detilPx.patients.birth_date,
      props.detilPx.created_at
    );
    let merge = `${age.y}${age.m}.${age.d}`;
    // console.log(merge, 3);
    let scale = 2;
    if (merge > 2) {
      scale = 5;
    }
    return scale;
  };

  return (
    <div>
      <div className="card">
        <div className="card-header">
          MTBS
          <button
            className="btn btn-sm btn-primary ml-3"
            onClick={(e) =>
              BlobPrint(`management/mtbs/print/${props.detilPx.id}`)
            }
          >
            {" "}
            cetak
          </button>
        </div>
        <div className="card-body">
          {refMtbs.map((data, key) => (
            <div className="card" key={key}>
              <div className="card-header">
                <b style={{ textTransform: "uppercase" }}>
                  {data.jenis_penilaian}
                </b>
              </div>
              <div className="card-body">
                {data.mtbs_list.map((list, ky) => (
                  <div key={ky}>
                    <div className="custom-control custom-checkbox mb-3">
                      <input
                        className="custom-control-input"
                        id={`mtbs_list_${list.id}`}
                        type="checkbox"
                        value={
                          param[`mtbs_list_${list.id}`] !== undefined
                            ? param[`mtbs_list_${list.id}`]
                            : false
                        }
                        onChange={(e) => handleCheck(e)}
                        defaultChecked={
                          list?.result?.result === "1" ? true : false
                        }
                      />
                      <label
                        className="custom-control-label"
                        htmlFor={`mtbs_list_${list.id}`}
                      >
                        {list.list_penilaian}
                      </label>
                    </div>
                    <div className="row">
                      {list.mtbs_attribut.map((att, k) => {
                        if (att.jenis === "check") {
                          return (
                            <div
                              className="custom-control custom-checkbox mb-3 ml-5"
                              key={k}
                            >
                              <input
                                className="custom-control-input"
                                id={`mtbs_attribut_${att.id}`}
                                type="checkbox"
                                value={
                                  param[`mtbs_attribut_${att.id}`] !== undefined
                                    ? param[`mtbs_attribut_${att.id}`]
                                    : att?.result?.result === "1"
                                    ? true
                                    : false
                                }
                                onChange={(e) => handleCheck(e)}
                                defaultChecked={
                                  att?.result?.result === "1" ? true : false
                                }
                              />
                              <label
                                className="custom-control-label"
                                htmlFor={`mtbs_attribut_${att.id}`}
                              >
                                {att.keterangan}
                              </label>
                            </div>
                          );
                        } else if (att.jenis === "input") {
                          return (
                            <div key={k} className="form-group row ml-4">
                              <div className="col-md-6">
                                <input
                                  className="form-control"
                                  type="text"
                                  id={`mtbs_attribut_${att.id}`}
                                  value={
                                    param[`mtbs_attribut_${att.id}`] !==
                                    undefined
                                      ? param[`mtbs_attribut_${att.id}`]
                                      : att.result?.result
                                      ? att.result?.result
                                      : ""
                                  }
                                  onChange={(e) => handleInput(e)}
                                />
                              </div>
                              <label
                                htmlFor={`mtbs_attribut_${att.id}`}
                                className="col-md-6 col-form-label form-control-label"
                              >
                                {att.keterangan}
                              </label>
                            </div>
                          );
                        }
                      })}
                    </div>
                  </div>
                ))}
              </div>
              <div className="card-footer bg-light">
                <div className="row">
                  <div className="form-group row ml-4 col-md-5">
                    <label
                      className="col-md-5 col-form-label form-control-label"
                      htmlFor={`klasifikasi_${data.id}`}
                    >
                      Klasifikasi
                    </label>
                    <div className="col-md-7">
                      {data.mtbs_klasifikasi.length > 0 ? (
                        <select
                          className="form-control"
                          id={`mtbs_klasifikasi_${data.id}`}
                          value={
                            param[`mtbs_klasifikasi_${data.id}`] !== undefined
                              ? param[`mtbs_klasifikasi_${data.id}`]
                              : data.klasifikasi_id
                              ? data.klasifikasi_id
                              : ""
                          }
                          onChange={(e) => handleInput(e)}
                        >
                          <option value="">pilih klasifikasi</option>
                          {data.mtbs_klasifikasi.map((d, ky) => (
                            <option key={ky} value={d.id}>
                              {d.klasifikasi}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <textarea
                          className="form-control"
                          id={`mtbs_klasifikasi_${data.id}`}
                        />
                      )}
                    </div>
                  </div>
                  <div className="form-group row ml-4 col-md-5">
                    <label
                      htmlFor={`mtbs_tindakan_${data.id}`}
                      className="col-md-5 col-form-label form-control-label"
                    >
                      Tindakan
                    </label>
                    <div className="col-md-7">
                      <textarea
                        className="form-control"
                        id={`mtbs_tindakan_${data.id}`}
                        value={
                          param[`mtbs_tindakan_${data.id}`] !== undefined
                            ? param[`mtbs_tindakan_${data.id}`]
                            : data.tindakan
                            ? data.tindakan
                            : ""
                        }
                        onChange={(e) => handleInput(e)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="card-footer">
          <div className="row">
            <button className="btn btn-primary ml-2" onClick={(e) => post()}>
              simpan{" "}
            </button>
            <button
              className="btn btn-warning ml-3"
              onClick={() => props.history.push("/pelayanan")}
            >
              tutup{" "}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Mtbs;
